import styled from "styled-components";
import { MappingConstants } from "../../rule-engine-core/Mapping/MappingConstants";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const XMappingItemRender = styled.div<{
    isDraggingOver?: boolean;
    size?: "Medium" | "Small";
    isInvalid?: boolean;
}>`
    width: 100%;
    position: relative;

    background: ${(props) =>
        props.isInvalid
            ? "transparent;"
            : props.isDraggingOver
              ? UIStyleConstants.GRAY_LIGHTER_COLOR
              : props.size === "Medium"
                ? "white"
                : "" + UIStyleConstants.GRAY_LIGHT_COLOR};

    .ActionsRender,
    .drag-connector {
        opacity: 0;
        transition: opacity 0.1s ease-in;
    }

    .ActionsRender {
        height: 0;
        width: 0;
    }

    ${(props) =>
        !props.isDraggingOver &&
        `
            .drag-connector.isdragging {
                opacity: 1;
            }

            &:hover .drag-connector,
            &:hover .ActionsRender {
                opacity: 1;

            }

            &:hover .ActionsRender {

                height: auto;
                width: auto;
            }
        `}
`;

export const XMappingDragItem = styled.div<{ size?: "Medium" | "Small"; isDragging?: boolean; highlighted?: boolean }>`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;

    ${(props) => (props.size === "Medium" ? "padding: 8px 16px;" : "padding: 2px 12px;")}

    border: 1px solid ${(props) =>
        props.highlighted ? MappingConstants.HIGHLIGHT_MAPPING_LINE_COLOR : "" + UIStyleConstants.GRAY_LIGHTER_COLOR};
    box-sizing: border-box;
    border-radius: 4px;

    ${(props) =>
        props.isDragging
            ? `
                background: ${UIStyleConstants.WHITE_COLOR};
            `
            : ``}

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
`;

export const XMappingListRender = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    overflow-y: auto;
    overflow-x: hidden;

    position: relative;
`;

export const XMappingSectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    //styleName: text/Inter Medium 14px;

    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;

    color: ${UIStyleConstants.BLUE_LIGHT_COLOR};

    padding: 17px 24px;
`;

export const ActionsRender = styled.div`
    position: absolute;
    bottom: 100%;
    right: 0;

    background: ${UIStyleConstants.WHITE_COLOR};
    border: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
    box-sizing: border-box;
    border-radius: 4px;

    display: flex;
    flex-direction: row;
`;

export const ActionButton = styled.div`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    background: ${UIStyleConstants.WHITE_COLOR};
    border-radius: 4px;
`;

export const StyledCircle = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 1px solid ${UIStyleConstants.BLUE_COLOR};
`;
